const serverLink = (file) => `${process.env.REACT_APP_API_URL}/files/${file.split('/').map(encodeURIComponent).join('/')}`;

export default serverLink;
